module.exports = __webpack_public_path__ + "img/expenditureItemIcon6.b9577813.png";